import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  moveInventoryModalTitle: {
    description: 'Move inventory modal title',
    defaultMessage: 'Move Stock',
    id: 'esSTJN',
  },
  moveInventoryModalCancel: {
    description: 'Move inventory cancel button',
    defaultMessage: 'Cancel',
    id: 'smkNuT',
  },
  moveInventoryModalMoveStock: {
    description: 'Move inventory Move Stock button',
    defaultMessage: 'Move Stock',
    id: 'ItU/AU',
  },
  moveInventoryFromHeader: {
    description: 'Move inventory Move Stock from header',
    defaultMessage: 'Move From',
    id: 'wvZCTd',
  },
  moveInventoryToHeader: {
    description: 'Move inventory Move Stock to header',
    defaultMessage: 'Move To',
    id: 'Mdpm4/',
  },
  moveInventoryOnHand: {
    description: 'Move inventory on hand label',
    defaultMessage: 'On Hand',
    id: 'ySiBSK',
  },
  moveInventoryAllocated: {
    description: 'Move inventory allocated label',
    defaultMessage: 'Allocated',
    id: 'Utr1qM',
  },
  moveInventoryAvailable: {
    description: 'Move inventory available label',
    defaultMessage: 'Available',
    id: '4mQFHe',
  },
  moveInventoryRemainingAfterTransfer: {
    description: 'Move inventory remaining after transfer label',
    defaultMessage: 'Remaining After Transfer',
    id: 'wP/sK6',
  },
  moveInventoryMoveAll: {
    description: 'Move inventory move all button',
    defaultMessage: 'All',
    id: '//y1Tg',
  },
  moveInventoryAddNewLocation: {
    description: 'Move inventory add new location option',
    defaultMessage: '+ Add New Location',
    id: '/IFFby',
  },
  moveInventoryWarningNegativeAvailable: {
    description: 'Move inventory warning when transfer makes available to sell negative',
    defaultMessage: 'This transfer will move inventory that may be needed for pending orders',
    id: 'U5APMX',
  },
  moveInventoryErrorNegativeOnHand: {
    description: 'Move inventory error when transfer makes on-hand negative',
    defaultMessage: 'Cannot move more stock than available at source location',
    id: 'da2SUQ',
  },
  moveInventoryErrorQuantityRequired: {
    description: 'Move inventory error when quantity is zero or empty',
    defaultMessage: 'Please enter a quantity',
    id: 'eWs5Qe',
  },
  moveInventoryErrorLocationRequired: {
    description: 'Move inventory error when destination location is not selected',
    defaultMessage: 'Please select a location',
    id: '5wO3MZ',
  },
  moveInventoryErrorFromWarehouseRequired: {
    description: 'Move inventory error when source warehouse is not selected',
    defaultMessage: 'Please select a source warehouse',
    id: 'Iazpgr',
  },
  moveInventoryErrorFromLocationRequired: {
    description: 'Move inventory error when source location is not selected',
    defaultMessage: 'Please select a source location',
    id: 'qjF3wb',
  },
  moveInventoryErrorQuantityExceedsAvailable: {
    description: 'Error shown when transfer quantity exceeds available (unallocated) inventory',
    defaultMessage: 'Cannot transfer more than available (unallocated) inventory.',
    id: '2LXUIf',
  },
});
